import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ITravelerInfo, IUserMDetails } from "../userManagementModel";
import moment from "moment";

export const getAllUsersM = createAsyncThunk(
  "User/FindAllUserForAdminPanel",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/User/FindAllUserForAdminPanel`,
        payload
      );
      return response.data.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching users:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getUserMRecentBookings = createAsyncThunk(
  "User/GetUserBussinessSummary",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/User/GetUserBussinessSummary`,
        payload
      );
      return response.data.Data?.RecentTrips || [];
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching users:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateUserM = createAsyncThunk(
  "User/UpdateUsersDetailForAdminPanel",
  async (UserData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/User/UpdateUsersDetailForAdminPanel`,
        UserData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating user:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getUserMById = createAsyncThunk(
  "User/FindByIDUserForAdminPanel",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/User/FindByIDUserForAdminPanel`,
        { ID: ID }
      );
      const result = response.data?.Data;
      return {
        Id: result.Id,
        user_guid: result.user_guid,
        first_name: result.first_name,
        last_name: result.last_name,
        mobile_no: result.mobile_no,
        email_id: result.email_id,
        date_of_birth: result.date_of_birth
          ? moment(result.date_of_birth, "YYYY-MM-DD").toDate()
          : "",
        gender: result.gender,

        nationality_name: result?.nationality_name,
        nationality_code: result?.nationality_code,
        country_name: result?.country_name,
        country_code: result?.country_code,
        state_name: result?.state_name,
        state_code: result?.state_code,
        city_name: result?.city_name,

        profile_photo: result.profile_photo,
        is_email_verified: result.is_email_verified,
        billing_address: result.billing_address,
        billing_pincode: result.billing_pincode,

        billing_country_name: result.billing_country_name,
        billing_country_code: result.billing_country_code,
        billing_state_name: result.billing_state_name,
        billing_state_code: result.billing_state_code,
        billing_city_name: result.billing_city_name,

        billing_pan_card_no: result.billing_pan_card_no,
        billing_gst_reg_name: result.billing_gst_reg_name,
        billing_pan_card_name: result.billing_pan_card_name,
        billing_gst_no: result.billing_gst_no,
        IsServiceCharge: result.IsServiceCharge,
        International_Conv_Fee: result.International_Conv_Fee,
        International_Cancellation_Fee: result.International_Cancellation_Fee,
        Domestic_Conv_Fee: result.Domestic_Conv_Fee,
        Domestic_Cancellation_Fee: result.Domestic_Cancellation_Fee,
        IsCreditLimit: result.IsCreditLimit,
        CreditLimit: result.CreditLimit,
        CreditDays: result.CreditDays,
        TravellersInformationList: result.TravellersInformationList?.map(
          (tInfo: any) => {
            return {
              id: tInfo.id,
              traveller_information_guid: tInfo.traveller_information_guid,
              user_id: tInfo.user_id,
              first_name: tInfo.first_name,
              last_name: tInfo.last_name,
              age_group: tInfo.age_group,
              date_of_birth: tInfo.date_of_birth
                ? moment(tInfo.date_of_birth, "YYYY-MM-DD").toDate()
                : "",
              initial: tInfo.initial,
              gender: tInfo.gender,
              mobile_no: tInfo.mobile_no,
              email_id: tInfo.email_id,
              pan_card_no: tInfo.pan_card_no,
              passport_no: tInfo.passport_no,
              expire_date: tInfo.expire_date
                ? moment(tInfo.date_of_birth, "YYYY-MM-DD").toDate()
                : "",
              issue_country_code: tInfo.issue_country_code,
              issue_country_name: tInfo.issue_country_name,
              country_code: tInfo.country_code,
            } as ITravelerInfo;
          }
        ),
        isactive: result.isactive === true ? 1 : 2,
      } as IUserMDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching states:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getCustomerDetailFromMobileNo = createAsyncThunk(
  "User/FindByMobileNoUserForAdminPanel",
  async (mobile_no: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/User/FindByMobileNoUserForAdminPanel`,
        { mobile_no }
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching WalletDetails:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// export const deleteTravallerInfo = createAsyncThunk(
//   "TravellersInformation/DeleteTravellersInformation",
//   async (ID: string) => {
//     try {
//       const response = await axiosApiInstance.post(
//         `${API_URL}/TravellersInformation/DeleteTravellersInformation`,
//         { traveller_information_guid: ID }
//       )
//       return response.data;
//     } catch (error: any) {
//       ErrorToast(error?.response?.data?.Details || "Something went wrong");
//       console.error("Error Delete Traveller:", error);
//       return Promise.reject({
//         message: error?.response?.data?.Details || "Something went wrong",
//       });
//     }
//   }
// );
